var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16.8,
    viewBox: "0 0 24 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_button",
    "data-name": "download button",
    d: "M20.16,9.548a3.6,3.6,0,0,0-3.36-4.9,3.582,3.582,0,0,0-2,.607A6,6,0,0,0,3.6,8.25c0,.1,0,.2.007.3A5.4,5.4,0,0,0,5.4,19.05H19.2a4.8,4.8,0,0,0,.96-9.5Zm-4.984,3.326-3.952,3.952a.6.6,0,0,1-.847,0L6.424,12.874a.6.6,0,0,1,.424-1.024H9.3V7.65a.6.6,0,0,1,.6-.6h1.8a.6.6,0,0,1,.6.6v4.2h2.453a.6.6,0,0,1,.424,1.024Z",
    transform: "translate(0 -2.25)",
    fill: "#ef5350"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cc7d012c37e27ed3727371c291486606.svg";
export { ForwardRef as ReactComponent };